<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 py-6 pb-32">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700">

      <div class="container mx-auto px-4 max-w-5xl">

        <h1 class="font-bold text-gray-800 mb-0 text-2xl text-center pt-5">
          ACREDITACIÓN DE PRENSA
        </h1>
        <h1 class="text-gray-800 mb-4 text-2xl text-center pt-2 pb-5">
          Por favor complete el formulario en su totalidad
        </h1>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">DNI / Pasaporte</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="numeric"  placeholder="DNI" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text"  placeholder="Nombre"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text"  placeholder="Apellido"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>


        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="text"  placeholder="Mail"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Medio</label>
            <Field name="empresa" v-slot="{ field , errors}" v-model="formData.empresa">
                <InputText v-bind="field" type="text"  placeholder="Medio" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Cargo</label>
            <Field name="cargo" v-slot="{ field , errors}" v-model="formData.cargo">
                <InputText v-bind="field" type="text"  placeholder="Cargo" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"/>
                <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import HeaderSection from './HeaderSection.vue';
import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, OrigenAcreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, ORIGEN_ACREDITADO, A_VERIFICAR } from "qreventos-suite/constantes";

export default defineComponent({
  components: {
    HeaderSection,
    InputText, BlockUI,
    Field, ErrorMessage, Form
  },
  created () {
    document.title = "EXPOSEG 2025 - Expositor";
  },
  data() {
    return {
      isSubmitting: false,
      formData: {
        nombre: '',
        apellido: '',
        documento: '',
        empresa: '',
        mail:  '',
        cargo: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        nombre: yup.string().required('Ingrese su nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese su apellido').min(3, 'Al menos 3 letras'),
        documento: yup.string().required('Ingrese su documento').min(7, 'Al menos 7 números'),
        empresa: yup.string().required('Ingrese su medio').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingrese su correo').email('Correo inválido'),
        cargo: yup.string().required('Ingrese su cargo')
      });
    }
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;

      let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni=" + this.formData.documento) as Acreditado;
      if (acreditadoExistente) {
        this.isSubmitting = false;

        Swal.fire({ 
            title: "Atención", 
            html: "El DNI / Pasaporte ingresado ya fue registrado.<br/><br/>Le enviamos un mail para informarle el estado de su registración. <br/><br/>Por favor revise su casilla de correo y de spam.",
            icon: "warning" 
          });
        return;
      }

      let acreditado:Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = { "id": 1333 } as TipoAcreditado;
      acreditado.estadoAcreditado = { "id": A_VERIFICAR } as EstadoAcreditado;
      acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.dni = this.formData.documento;
      acreditado.cargo = this.formData.cargo;
      acreditado.empresa = this.formData.empresa;
      acreditado.mail = this.formData.mail;      
      acreditado.modificado = SAVE;
      acreditado.cantidad = 1;
      acreditado.notificar = true;
      acreditado.notificarWhatsApp = false;    

      try {
        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);
        
        Swal.fire({
            title: "Acreditación exitosa",
            html: "Su registro se realizó con éxito.<br/><br/>Una vez validada su acreditación recibirá un mail para poder descargarse su credencial.<br/><br/>Por favor revise su casilla de correo y de spam.",
            icon: "success",
        }).then(() => {
          window.location.href = "https://www.exposeg.com.ar";
        });

      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  }
});
</script>
